import { useContext } from 'react';
import SubstatusContext from 'src/contexts/substatus/substatusContext';

const useSubstatus = () => useContext(SubstatusContext);

export default useSubstatus;
